<form [formGroup]="quillForm">
	<quill-editor
		#editor
		(dragover)="(false)"
		[modules]="quillModuleConfig"
		(onContentChanged)="logChange($event)"
		(onSelectionChanged)="logSelection($event)"
		(onEditorCreated)="created($event)"
		formControlName="editorCtrl"
		[readOnly]="readOnly"
		[minLength]="minLength"
		[maxLength]="maxLength"
		(paste)="onPaste($event)"
		placeholder="{{ quillPlaceholder }}"
		id="quillEditor"
	>
	</quill-editor>
	<div fxLayoutAlign="end end">
		<!-- <mat-error class="m-l-s" *ngIf="quillForm.controls?.editorCtrl?.invalid"
			>
			<img style="position:relative; top:3px" width="16px" height="16px" src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/infoWarn/public"/>
			Maximum characters limit exceeded by {{ characterLength - maxLength }} characters</mat-error
		> -->
		<mat-error
			class="m-l-s"
			*ngIf="quillForm.controls?.editorCtrl?.invalid"
			fxLayout="row"
			fxLayoutAlign="start center"
		>
			<div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="start center">
				<img
					fxFlex="5%"
					src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/infoWarn/public"
				/>
				<span i18n="@@character_limit_exceeded"
					>Please check the character limits and remove emoji.</span
				>
			</div>
		</mat-error>

		<div fxFlex fxLayoutAlign="end end">
			<mat-hint class="mat-caption m-r-xs"
				><span class="mat-subtitle-2">{{ characterLength }}</span> / {{ maxLength }}
				<span i18n="@@characters_translation">character</span>
			</mat-hint>
		</div>
	</div>
</form>
<!-- DEBUG: uncomment below line to see data crated by quill -->
<!-- <pre>{{ quillForm.get('editorCtrl')?.value }}</pre> -->
